$(document).ready(function(){

  $('body').on('click','.custom-mobile-link', function(e){
    if ($(window).width() > 797) {
      console.log('clicked mobile mega parent');
      $(this).closest('label').click();  
    } else {
      e.preventDefault();
      $(this).next(".close-dropdown").trigger("click");
    }
  });

  $('.product-thumbnail__title').matchHeight();
  $('.thumbnail__caption').matchHeight();
  $('.thumbnail-add-to-cart__caption .product-thumbnail').matchHeight();
  
  $('.blog-card__content .title').matchHeight();
  $('#panel-articles .title').matchHeight();
  if ( $('.custom-landing-page-image-grid-section .wulf-overlap-title').length ) {
    $('.custom-landing-page-image-grid-section .wulf-overlap-title').matchHeight();
  }

  
  
  var featuredReviewsSlider = $('#featuredReviewsWrapper');

  $(featuredReviewsSlider).flickity({
    lazyLoad: 2,
    freeScroll: true,
    imagesLoaded: true,
    draggable: true,
    autoPlay: true,
    cellAlign: 'center',
    wrapAround: true,
    pageDots: true,
    contain: true,
    prevNextButtons: true,
    initialIndex: 0,
    on: {
      ready: function ready() {
        // Reset layout to avoid collapsing issues
        setTimeout(function () {
          $(featuredCollectionSlider).flickity('resize');
        }, 500);
      }
    }
  });

  if ( $('#customFieldChefs').length ) {
    $('#customFieldChefs').flickity({
      wrapAround: true,
      imagesLoaded: false,
      initialIndex: 1,
      autoPlay: true,
      pauseAutoPlayOnHover: false,
      pageDots: false,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            $(customFieldChefs).flickity('resize');
            $(customFieldChefs).fadeIn().css('opacity','1');
          }, 600);
        }
      }
    });
    $('#chefTestimonialPrev').on('click',function(){
      $('#customFieldChefs').flickity( 'previous' )
    });
    $('#chefTestimonialNext').on('click',function(){
      $('#customFieldChefs').flickity( 'next' )
    });
  }

  if ( $('#articleImageGallery').length ) {
    $('#articleImageGallery').flickity({
      wrapAround: true,
      imagesLoaded: true,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            $(articleImageGallery).flickity('resize');
            $(articleImageGallery).fadeIn().css('opacity','1');
          }, 500);
        }
      }
    });
  }

  /*
  var $wrapper = $('#articlesWrapper');

  $wrapper.find('.featured-article').sort(function(a, b) {
    console.log(a.dataset.updated, b.dataset.updated, a.dataset.updated > b.dataset.updated);
    return a.dataset.updated > b.dataset.updated;
  })
  .appendTo($wrapper);
  */


  $("#articlesWrapperx .featured-article").sort(sort_li) // sort elements
                    .appendTo('#articlesWrapper'); // append again to the list

  $("#articlesWrapper").css('opacity',1);
  // sort function callback
  function sort_li(a, b){
    console.log(($(b).data('updated')) < ($(a).data('updated')) ? -1 : 1);
      return ($(b).data('updated')) < ($(a).data('updated')) ? -1 : 1;    
  }

  atcFormIsInView();


  var $cartAccordionHeading = $('#cartShippingMotivator .faq-accordion > dt > button');

  console.log($cartAccordionHeading);
  $('#cartShippingMotivator .faq-accordion > dd').attr('aria-hidden', true);
  $cartAccordionHeading.attr('aria-expanded', false);
  $cartAccordionHeading.on('click activate', function () {
    console.log('accordion click cart');
    var faqTitle = $(this);
    var faqIcons = $(this).find('.icon');
    var state = $(this).attr('aria-expanded') === 'false' ? true : false;
    $(this).attr('aria-expanded', state);
    $(this).parent().next().slideToggle(function () {
      if (faqIcons.hasClass('icon--active')) {
        faqIcons.toggleClass('icon--active');
      }
    });
    $(this).parent().next().attr('aria-hidden', !state);
    if ( $('#panel-articles').length ) {
      var minTitleHeight = 0;
      var minImageHeight = 0;
      $('#panel-articles .image-element__wrap').each(function(){
        console.log($(this).height());
        if ( $(this).height() > minImageHeight ) {
          minImageHeight = $(this).height();
        }
      });
      $('#panel-articles .image-element__wrap').each(function(){
        $(this).height(minImageHeight);
      });
      console.log({minImageHeight});

    }
    return false;
  });

  $('body').on('click','.cart-accordion__button',function(){
    console.log('real cart accordion click');
    var faqIcons = $(this).find('.icon');
    var state = $(this).attr('aria-expanded') === 'false' ? true : false;
    $(this).attr('aria-expanded', state);
    $(this).parent().next().slideToggle(function () {
      if (faqIcons.hasClass('icon--active')) {
        faqIcons.toggleClass('icon--active');
      }
    });
    $(this).parent().next().attr('aria-hidden', !state);
    return false;
  });

  // cart champion popup
  $("#cart_form #checkout").on("click", function(e) {
    var champion_popup = $(".cart-champion-popup");
    if (champion_popup.length > 0 && champion_popup.hasClass("popup-hide")) {
      e.preventDefault();
      champion_popup.removeClass("popup-hide");
      champion_popup.attr("data-flag", "cartPage");
    }
  })

  $('[data-ajax-cart-drawer]').on("click", ".button--add-to-cart", function(e) {
    var champion_popup = $(".cart-champion-popup");
    if (champion_popup.length > 0 && champion_popup.hasClass("popup-hide")) {
      e.preventDefault();
      champion_popup.removeClass("popup-hide");
      champion_popup.attr("data-flag", "drawer");
    }
  })
  $(".shopify-payment-button").on("click", function(e) {
    var champion_popup = $(".cart-champion-popup");
    if (champion_popup.length > 0 && champion_popup.hasClass("popup-hide")) {
      e.preventDefault();
      e.stopPropagation();
      champion_popup.removeClass("popup-hide");
      champion_popup.attr("data-flag", "BuyNow");
    }
  })

  $(".cart-champion-popup .fc-item").on("click", function() {
    var notes = $(this).data("note");

    if ($(".cart-champion-popup").attr("data-flag") == "drawer") {
      var origin_notes = $('.ajax-cart__form textarea[name="note"]').text();
      var index = origin_notes.indexOf("Superbowl");
      console.log(index);
      if (index > 0) {
        origin_notes = origin_notes.substr(0, index);  
      } else {
        origin_notes = '';
      }
      console.log(origin_notes);
      var final_notes = origin_notes + " " + notes;
      $('.ajax-cart__form textarea[name="note"]').text(final_notes);
      $(".ajax-cart__form .button--add-to-cart").trigger("click");
    } else if ($(".cart-champion-popup").attr("data-flag") == "BuyNow") {
      var updateData = {
        'note': notes
      };
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      })
      .then(response => {
        $(".shopify-payment-button").trigger("click");
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    } else {
      var origin_notes = $('#cart_form .cart__notes textarea[name="note"]').text();
      var index = origin_notes.indexOf("Superbowl");
      if (index > 0) {
        origin_notes = origin_notes.substr(0, index);  
      }  else {
        origin_notes = '';
      }
      var final_notes = origin_notes + " " + notes;
      $('#cart_form .cart__notes textarea[name="note"]').text(final_notes);
      $("#cart_form #checkout").trigger("click");
    }
  })


  $('.wholesale-slides').slick({
    dots: true,
    infinite: true,
    arrows: true
  });

  // Wholesale Featured List slider
  $('.wholesale-featured-slides').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 800,
        /*
        settings: unslick
        */
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          infinite: true,
          arrows: false
        }
        
      }
    ]
  }); 
  
  $('.featured-list-slider-nav').on('init', function(event, slick){
    $slideNodes = $(this).find('.thumbnail-image');
    $slideNodes.each(function(){
      $(this).addClass('found-thumb-wulf');
      $(this).contents().filter(function() {
        // get only the text nodes
        return this.nodeType === 3;
      })
      .remove();
    });
    $(this).addClass('wulf-init');
  });
  
  function initFeaturedSlides() {
    $('.featured-list-slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: true,
      asNavFor: '.featured-list-slider-nav'
    });
    $('.featured-list-slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical:true,
      infinite: true,
      asNavFor: '.featured-list-slider-for',
      dots: false,
      focusOnSelect: true,
      verticalSwiping:true,
      responsive: [
        {
          breakpoint: 580,
          settings: {
            vertical: false,
          }
        }
      ]
    });
  }

  function destroyFeaturedSlides() {
    $('.featured-list-slider-for').slick('unslick');
    $('.featured-list-slider-nav').slick('unslick');
  }

  initFeaturedSlides();
  
  $('body').on('click', '.wholesale-featured-slide', function() {
    var dataNum = $(this).data('num');
    $('.wholesale-featured-list').removeClass('active');
    //$('.wholesale-featured-list[data-num="' + dataNum + '"]').addClass('active');
    
    var $newActiveSlide = $('.wholesale-featured-list[data-num="' + dataNum + '"]');
    console.log($newActiveSlide);
    $newActiveSlide.addClass('active');
    
    
    $([document.documentElement, document.body]).animate({
        scrollTop: $newActiveSlide.offset().top + (-100)
    }, 1000);
    
    
    destroyFeaturedSlides();
    initFeaturedSlides()
    
  });
  

});

$(window).on('scroll', function () {
  atcFormIsInView();
});

function atcFormIsInView() {
  var $buttons = $('.purchase-details__buttons');
  var $details = $('.purchase-details.desktop-hide');
  
  if ($buttons.length && $details.length) {
    var top = $(window).scrollTop(),
        bottom = $(window).scrollTop() + $(window).height(),
        divTop = $details.offset().top - 30,
        divHeight = $buttons.outerHeight(),
        divBottom = divTop + divHeight + 30;

    if (divBottom > top && divTop < bottom) {
      $('body').removeClass('add-to-cart-out-of-view');
    } else {
      $('body').addClass('add-to-cart-out-of-view');
    }
  }
}





$("#giftMessage").on('change keyup paste', function() {
  console.log('change');
  console.log($(this));
  console.log($(this).html());
});


/*
$('body').on('change keyup paste', '#giftMessage', function() {
  console.log('change');
  console.log($(this));
  console.log($(this).val());
  var dynamicGiftMessage = $(this).val();
  
  var attributeString = `attributes[Gift wrap]=Yes`;
  $.post('/cart/update.js', );
});
*/
$('body').on('focusout ', '#giftMessage', function() {
  console.log('change');
  console.log($(this));
  var dynamicGiftMessage = $(this).val();
  console.log(dynamicGiftMessage);
  
  var attributeString = `attributes[gift_message]=${dynamicGiftMessage}`;
  console.log(attributeString);
  $.post('/cart/update.js', attributeString);
});
$('body').on('focusout ', '#note', function() {
  console.log('change');
  console.log($(this));
  var dynamicNote = $(this).val();
  console.log(dynamicNote);
  
  //var attributeString = `attributes[gift_message]=${dynamicGiftMessage}`;
  //console.log(attributeString);
  $.post('/cart/update.js', {note: dynamicNote});
});

/***** make the whole quickview overlay a trigger for quickview **/
document.addEventListener('DOMContentLoaded', function() {
  // Attach click event listener to all elements with class 'thumbnail-overlay__container'
  //  document.querySelectorAll('.thumbnail-overlay__container').forEach(function(container) {
  //    container.addEventListener('click', function(event) {
  //      console.log("lets pass this on to the button. the target is...");
  //      console.log(event.target);
  //      // Find the first child element with class 'js-quick-shop-link' and click it
  //      var quickShopLink = container.querySelector('.js-quick-shop-link');
  //      if (quickShopLink) {
  //        quickShopLink.click();
  //      }
  //    });
  //  });

    // Attach click event listener to the document or a more specific parent that exists on page load
    document.addEventListener('click', function(event) {
      // Use event delegation to check if the clicked element matches your target
      // or is a descendant of an element that matches your target
      if (event.target.matches('.custom-hello-retail-quick-shop__buttons, .custom-hello-retail-quick-shop__buttons')) {
        // If so, just perform the default action and don't propagate further to prevent the double action
        console.log("Button or its child clicked directly. the target was");
        //console.log(event.target);
        return; // Exit the function early
      }
      var imageDirect = event.target.closest('.aw-image');
      if ( imageDirect ) {
        return;
      }
      var searchContainer = event.target.closest('.hr-results-container');
      if (searchContainer) {
        return; // there is no quick shop on the search overlay so exit
      }
      var searchOverlayProduct = event.target.closest('.hr-search-overlay-product');
      if (searchOverlayProduct) {
        return; // exit if within a search overlay product element
      }

      var container = event.target.closest('.aw-item.quick-shop--true');

      if (container) {
        event.preventDefault(); // Prevent default action if needed
        console.log(event);

        // Find the first child element with class '.custom-hello-retail-quick-shop__buttons' and click it
        var quickShopLink = container.querySelector('.custom-hello-retail-quick-shop__buttons');
        if (quickShopLink) {
          quickShopLink.click();
        } else {
          event.target.click();
        }
      }
    });

    document.body.addEventListener('change', function(event) {
        // Ensure the event is coming from our specific variant selector
        if (event.target.matches('[data-variant-selector]')) {
          // Find the closest parent that includes both the selector and the price display
          var container = event.target.closest('.quick-shop-content-right');

          // Extract the new price from the selected option
          var selectedOption = event.target.options[event.target.selectedIndex];
          var newPrice = selectedOption.getAttribute('data-price');

          // Update the price display within the same container
          var priceDisplayElement = container.querySelector('.js-current-price .money');
          if (priceDisplayElement) {
              priceDisplayElement.textContent = newPrice;
          }
      }

    });

}); 

document.addEventListener('DOMContentLoaded', function() {
  // Flag to track if the modal class was added
  let modalClassAdded = false;

  // Create a MutationObserver to watch for changes to the body element's class attribute
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        const bodyClassList = document.body.classList;
        // Check if the modal class is added
        if (bodyClassList.contains('rebuy-modal-visible')) {
          modalClassAdded = true;
        }
        // Check if the modal class was added and is now removed, and if the collection class is still present
        if (modalClassAdded && !bodyClassList.contains('rebuy-modal-visible') && bodyClassList.contains('collection')) {
          //observer.disconnect();
          console.log("this is a collection page rebuy cart closure");
//// use the new cart data to update the page
          async function updateCartQtys() {
            try {
              // Fetch cart data
              const response = await fetch('/cart.js');
              const cart = await response.json();
          
              // Extract [product title, variant ID, quantity]
              const cartData = cart.items.map(item => [item.product_title, item.product_id, item.variant_id, item.quantity]);
          
              console.log(cart); // Log cart data for debugging
              console.log(cartData); // Log cart data for debugging
          
              // Update cart count
              document.querySelectorAll('.header-cart__count[data-bind="itemCount"]').forEach(cartCountElement => {
                cartCountElement.textContent = cart.item_count;
                console.log(`Updated cart count to ${cart.item_count}`);
              });
            
              // Loop through cart items
              cartData.forEach(([title, productId, variantId, quantity]) => {
                // Select all matching option elements by variant ID
                const options = document.querySelectorAll(`option.annotated-option[value="${variantId}"]`);
                
                if (options.length > 0) {
                  options.forEach(option => {
                    option.setAttribute('data-cart-qty', quantity);
                    console.log(`Updated variant ${variantId} to cart quantity ${quantity}`);
                  });
                } else {
                  console.log(`No matching option found for variant ID: ${variantId}`);
                }

                const purchaseDetails = document.querySelectorAll(`.purchase-details__quantity[data-cart-item-variant-id="${variantId}"]`);

                if (purchaseDetails.length > 0) {
                  purchaseDetails.forEach(detail => {
                    const inputField = detail.querySelector('.quantity-input');
                    if (inputField) {
                      inputField.value = quantity;
                      console.log(`Updated input for variant ${variantId} to cart quantity ${quantity}`);
                    }
                  });
                } else {
                  console.log(`No matching purchase-details__quantity found for variant ID: ${variantId}`);
                }


              });

              /// now make sure any item removed from cart reverts back to the ATC button instead of the qty controls
              // Get all elements with data-purchase-details-product-id and data-purchase-details-quantity-product-id
              const purchaseDetailElements = document.querySelectorAll('[data-purchase-details-product-id]');
              purchaseDetailElements.forEach(element => {
                const productId = element.getAttribute('data-purchase-details-product-id');
                // Check if the product ID exists in the cart
                const inCart = cartData.some(([, cartProductId]) => cartProductId == productId);
                // Add or remove the 'qty-in-cart' class
                if (inCart) {
                  element.classList.add('item-in-cart-purchase-details');
                  //console.log(`Added class item-in-cart-purchase-details to product ${productId}`);
                } else {
                  element.classList.remove('item-in-cart-purchase-details');
                  //console.log(`Removed class item-in-cart-purchase-details from product ${productId}`);
                }
              });

              const purchaseDetailQtyElements = document.querySelectorAll('[data-purchase-details-quantity-product-id]');
              purchaseDetailQtyElements.forEach(element => {
                const productId = element.getAttribute('data-purchase-details-quantity-product-id');
                // Check if the product ID exists in the cart
                const inCart = cartData.some(([, cartProductId]) => cartProductId == productId);
                // Add or remove the 'qty-in-cart' class
                if (inCart) {
                  element.classList.add('item-in-cart-show-qty');
                  //console.log(`Added class item-in-cart-show-qty to product ${productId}`);
                } else {
                  element.classList.remove('item-in-cart-show-qty');
                  //console.log(`Removed class item-in-cart-show-qty from product ${productId}`);
                }
              });

            } catch (error) {
              console.error('Error fetching or updating cart data:', error);
            }
          }
          
          // Call the function
          updateCartQtys();

//// end use the new cart data to update the page
          
          
          // Once the modal is closed, we no longer need to observe changes
          //window.location.reload();
        } else if (modalClassAdded && !bodyClassList.contains('rebuy-modal-visible') && bodyClassList.contains('index')) {
          observer.disconnect();
          console.log("this is an index page rebuy cart closure");
          // Once the modal is closed, we no longer need to observe changes
          //window.location.reload();
        }
      }
    });
  });

  // Start observing the body element for attribute changes
  observer.observe(document.body, {
    attributes: true
  });


    // Get all swatch inputs
    const swatchInputs = document.querySelectorAll('.swatch input[type="radio"]');
    // Add event listener to each swatch input
    swatchInputs.forEach(input => {
      input.addEventListener('change', function() {
        // Get the value of the selected swatch input
        const selectedValue = this.value;
        console.log({selectedValue});
        // Find the parent form of the clicked swatch input
        const parentForm = this.closest('form');
        // Find the select element within the parent form
        const selectElement = parentForm.querySelector('select[name="id"]');
        console.log({selectElement});
        const options = selectElement.options;
        for (let i = 0; i < options.length; i++) {
          if (options[i].text === selectedValue) {
            // Change the select element to match the selected swatch input
            selectElement.selectedIndex = i;
            const selectedPrice = options[i].getAttribute('data-price');
            const qtyInCart = parseInt(options[i].getAttribute('data-cart-qty'), 10);
            const lineItemInCart = parseInt(options[i].getAttribute('data-cart-line-index'), 10);
            const variantIdItemInCart = parseInt(options[i].getAttribute('data-cart-item-option-variant-id'), 10);
            console.log({ selectedPrice });
            console.log({ qtyInCart });
            console.log({ variantIdItemInCart });
            const price = parseFloat(selectedPrice.replace('$', ''));
            const dollars = Math.floor(price);
            const cents = Math.round((price - dollars) * 100);
            const productWrap = parentForm.closest('.product-wrap');
            if (parentForm) {
              const purchaseDetails = parentForm.querySelector('.purchase-details');
              const atcPrice = parentForm.querySelector('.in-atc-price');
              atcPrice.textContent=selectedPrice;
              const qtyWrapper = parentForm.querySelector('.purchase-details__quantity');
              console.log({purchaseDetails}, qtyInCart);
              const inputElement = parentForm.querySelector('.quantity-input');
              const purchaseDetailsQuantity = parentForm.querySelector('.purchase-details__quantity');
              purchaseDetailsQuantity.setAttribute('data-cart-item-variant-id',variantIdItemInCart);
              if (qtyInCart > 0) {
                purchaseDetails.classList.add('item-in-cart-purchase-details');
                qtyWrapper.classList.add('item-in-cart-show-qty');
                inputElement.value = qtyInCart;
                inputElement.setAttribute('data-line-id',lineItemInCart);
                purchaseDetailsQuantity.setAttribute('data-line-item',lineItemInCart);
                purchaseDetailsQuantity.setAttribute('data-line-item-key',lineItemInCart);

              } else {
                inputElement.value = 1;
                purchaseDetails.classList.remove('item-in-cart-purchase-details');
                qtyWrapper.classList.remove('item-in-cart-show-qty');
              }
            }
            if (productWrap) {
              const dollarElement = productWrap.querySelector('.thumbnail-price-dollars');
              const centsElement = productWrap.querySelector('.thumbnail-price-cents');
              if (dollarElement) {
                dollarElement.textContent = dollars;
              }
              if (centsElement) {
                centsElement.textContent = cents < 10 ? '0' + cents : cents;
              }
            }
            break;
          }
        }
      });
    });
  
});

/**** hello retail quick shop attempt */
document.addEventListener('click', function(event) {
  if (event.target.matches('.custom-hello-retail-quick-shop__buttons, .custom-hello-retail-quick-shop__buttons *')) {
      // Prevent default action
      event.preventDefault();
      event.stopPropagation();
      console.log("quick shop");
      // Extract the value of the 'data-dynamic-handle' attribute
      var dynamicHandle = event.target.getAttribute('data-dynamic-handle');
      
      // Construct the URL
      var targetUrl = "https://wulfsfish.com/products/" + dynamicHandle + "?view=bare";
      console.log("let's load up the data from ", targetUrl);
      // Use fetch API to get the content of the URL
      fetch(targetUrl)
          .then(response => {
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              return response.text();
          })
          .then(html => {
              // Assuming Fancybox V3+
              // Display the fetched HTML content in a Fancybox instance
              $.fancybox.open(html, {
                  type: 'html',
                  baseClass: 'quick-shop__lightbox custom-hello-retail__lightbox',
                  opts: {
                      // Your fancybox options here
                      afterShow: function(instance, current) {
                          console.log('Content displayed in Fancybox');
                      }
                  }
              });
          })
          .catch(error => {
              console.error('Error fetching and displaying content in Fancybox:', error);
          });
  }
});

/*  
LETS REMOVE THIS FOR NOW
IT CLICKED ON THE MOST RECENTLY ADDED TO CART VARIANT BUT IT IS AN UNNECESSARY COMPLICATION WITH THE NEW VARIANT ID BASED ATC
document.addEventListener("DOMContentLoaded", function() {
  // Get all select elements
  const selectElements = document.querySelectorAll('select[data-variant-selector]');

  selectElements.forEach(selectElement => {
    const options = selectElement.querySelectorAll('option');
    let lowestIndexOption = null;
    let lowestIndex = Infinity;

    // Iterate over the options to find the one with the highest data-cart-line-index
    options.forEach(option => {
      const cartLineIndex = option.getAttribute('data-cart-line-index');
      if (cartLineIndex !== null) {
        const index = parseInt(cartLineIndex, 10);
        if (index < lowestIndex) {
          lowestIndex = index;
          lowestIndexOption = option;
        }
      }
    });
    //console.log({selectElement})
    //console.log("highest index was", lowestIndex);

    // If no valid option with a cart line index is found, skip to the next select element
    if (!lowestIndexOption || lowestIndex === -1) return;

    const highestText = lowestIndexOption.textContent.trim();

    console.log({highestText})
    const parentContainer = selectElement.closest('form');
    
    if (!parentContainer) return;

    const swatchInput = parentContainer.querySelector(`.swatch input[value="${highestText}"]`);

    // If the swatch input is found, click it
    if (swatchInput) {
      swatchInput.click();
    }
  });
});
*/

document.querySelectorAll('[data-value-handle-link]').forEach(linkElement => {
  linkElement.addEventListener('click', function () {
    const linkValue = this.getAttribute('data-value-handle-link');
    const targetInput = document.querySelector(`[data-value-handle-target="${linkValue}"]`);
    const buttonGroup = this.closest('.image-variant-buttons');
    if (buttonGroup) {
      buttonGroup.querySelectorAll('.image-variant-button').forEach(button => {
        button.classList.remove('image-variant-button-active');
      });
      this.classList.add('image-variant-button-active');
    }
    
    if (targetInput) {
      targetInput.click();
      console.log(`Clicked on target input:`, targetInput);
    } else {
      console.log(`No target input found for: ${linkValue}`);
    }
  });
});

document.querySelectorAll('.thumbnail-overlay__container').forEach(element => {
  element.addEventListener('mouseover', () => {
  });
});

document.querySelectorAll('.quick-shop__buttons').forEach(container => {
  container.addEventListener('click', (event) => {
    console.log(event.target);
    const quickShopButton = container.querySelector('.js-quick-shop-link');
    if (quickShopButton) {
      quickShopButton.click();
      console.log('would have referred click here.'); 
      //console.log(quickShopButton);
    } else {
      console.log('No quick shop button found in this container.'); 
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Find all variant options launcher elements
  const variantLaunchers = document.querySelectorAll('.variant-options-launcher');
  
  // Add hover event listeners to each launcher
  variantLaunchers.forEach(launcher => {
    // Add mouseenter event
    launcher.addEventListener('mouseenter', function() {
      // Find the parent product-image__wrapper element
      const productWrapper = this.closest('.product-image__wrapper');
      if (productWrapper) {
        // Add a hover class to simulate hover state
        productWrapper.classList.add('hovered');
      }
    });
    
    // Add mouseleave event
    launcher.addEventListener('mouseleave', function() {
      // Find the parent product-image__wrapper element
      const productWrapper = this.closest('.product-image__wrapper');
      if (productWrapper) {
        // Remove the hover class
        productWrapper.classList.remove('hovered');
      }
    });

    launcher.addEventListener('click', function(e) {
      // Prevent the default action
      e.preventDefault();
      
      // Find the parent product wrapper
      const productWrapper = this.closest('.product-image__wrapper');
      
      if (productWrapper) {
        // Find the quick shop link within this product wrapper
        const quickShopLink = productWrapper.querySelector('.js-quick-shop-link');
        
        // Trigger a click on the quick shop link if it exists
        if (quickShopLink) {
          quickShopLink.click();
        }
      }
    });

    
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Find all thumbnail quickview trigger elements
  const thumbnailTriggers = document.querySelectorAll('.thumbnail-quickview-trigger');
  
  // Add click event to each thumbnail trigger
  thumbnailTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      // Prevent the default action
      e.preventDefault();
      
      // Find the parent product wrap
      const productWrap = this.closest('.product-wrap');
      
      if (productWrap) {
        // Find the quick shop link within this product wrapper
        const quickShopLink = productWrap.querySelector('.js-quick-shop-link');
        
        // Trigger a click on the quick shop link if it exists
        if (quickShopLink) {
          quickShopLink.click();
        } else {
          console.log('Quick shop link not found in this product wrapper');
        }
      } else {
        console.log('Product wrap not found for this trigger');
      }
    });
  });
});